

export default {
  enums: [
    { id: 'PRINTED' },
    { id: 'VERIFIED' },
  ]
};